import { render, staticRenderFns } from "./battey.vue?vue&type=template&id=653b64a2&scoped=true"
import script from "./battey.vue?vue&type=script&lang=js"
export * from "./battey.vue?vue&type=script&lang=js"
import style0 from "./battey.vue?vue&type=style&index=0&id=653b64a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653b64a2",
  null
  
)

export default component.exports